import { Link } from 'react-router-dom';
import { CONTACT_EMAIL } from '../../pages/LandingPage';

export default function Footer() {
  return (
    <footer className="bg-[#0a1628] text-white">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-4 px-4 py-8 text-sm sm:flex-row sm:justify-between sm:px-6 lg:px-8">
        <p className="text-white/80">© {new Date().getFullYear()} DiSCX-US LLC. All rights reserved.</p>
        <nav className="flex items-center gap-5">
          <Link to="/terms" className="text-white/80 hover:text-white">Terms of Service</Link>
          <Link to="/privacy" className="text-white/80 hover:text-white">Privacy Policy</Link>
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-white/80 hover:text-white">{CONTACT_EMAIL}</a>
        </nav>
      </div>
    </footer>
  );
}
